export const removeRepeatingForwardSlashes = (input: string): string => {
  return input.replace(/\/{2,}/g, '/');
};

const DASHBOARD_API_PREFIX = `/api/dashboard/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}`;

export const BASE_URLS = {
  CRMS: `${process.env.REACT_APP_BASE_URL}/api/gwf/v1/ez/webform`,
};

export const INBOX_ENDPOINT = {
  GET_INBOX_MESSAGES: removeRepeatingForwardSlashes(
    `${DASHBOARD_API_PREFIX}/ez/inbox/messages`
  ),
  GET_INBOX_SEARCH: removeRepeatingForwardSlashes(
    `${DASHBOARD_API_PREFIX}/ez/inbox/messages/search`
  ),
  GET_INBOX_MESSAGE_DETAILS: removeRepeatingForwardSlashes(
    `${DASHBOARD_API_PREFIX}/ez/inbox/message`
  ),
  INBOX_MESSAGE_STATUS: removeRepeatingForwardSlashes(
    `${DASHBOARD_API_PREFIX}/ez/inbox/messages/status`
  ),
};

export const GWF_ACKNOWLEDGE_ENDPOINT = removeRepeatingForwardSlashes(
  `/api/gwf/${process.env.REACT_APP_API_VERSION_PREV}/ez/process`
);

export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';

export const CRMS_ENDPOINT = {
  getToken: `${process.env.REACT_APP_BASE_URL}/api/authez/v2/ez/session`,
  clarification: `${BASE_URLS.CRMS}/clarification`,
  input: `${BASE_URLS.CRMS}/input`,
  survey: `${BASE_URLS.CRMS}/survey`,
  surveyUnsubscribe: `${BASE_URLS.CRMS}/survey/unsubscribe`,
  submitFeedback: `${BASE_URLS.CRMS}/feedback`,
};

export const DMS_ENDPOINT = {
  getScanResult: `${process.env.REACT_APP_DMS_BASE_URL}/initiate-scan`,
  getScanResultOnly: `${process.env.REACT_APP_DMS_BASE_URL}/scan-results`,
  retrieveDocumentInternet: `${process.env.REACT_APP_DMS_BASE_URL}/internet-document`,
  retrieveDocumentIntranet: `${process.env.REACT_APP_DMS_BASE_URL}/intranet-document`,
};

export const CORS_HEADERS = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Headers': '*',
  'Access-Control-Allow-Methods': '*',
  'X-Frame-Options': 'ALLOW-FROM https://www-acra-gov-sg.cwp-stg.sg',
};
